"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetRolePrivilegesResponse = exports.GetRolesSummaryResponse = exports.UpdateRoleResponse = exports.GetRoleResponse = exports.CreateRoleResponse = void 0;
class CreateRoleResponse {
}
exports.CreateRoleResponse = CreateRoleResponse;
class GetRoleResponse {
}
exports.GetRoleResponse = GetRoleResponse;
class UpdateRoleResponse {
}
exports.UpdateRoleResponse = UpdateRoleResponse;
class GetRolesSummaryResponse {
}
exports.GetRolesSummaryResponse = GetRolesSummaryResponse;
class GetRolePrivilegesResponse {
}
exports.GetRolePrivilegesResponse = GetRolePrivilegesResponse;
//# sourceMappingURL=role.js.map